<template>
  <div id="orderDetail">
	  <plugin />
	  <Pay  ref="edit" v-if='orderPayShow' :orderid='orderPayid' />
    <div class="order-status">
		<img src="../assets/order-status-bg.png" class="status-bg" />
    <div class="order-content">
        <div class="icon">
            <img src="../assets/icon-order-status1.png" />
        </div>
       <div class="text" v-if='orderDetail.order_status==0'>待支付</div>
        
       <div class="text" v-else-if='orderDetail.order_status==7'>待发货</div>
       <div class="text" v-else-if='orderDetail.order_status==2'>已发货</div>
       <div class="text" v-else-if='orderDetail.order_status==-1'>已取消</div>
       <div class="text" v-else-if='orderDetail.order_status==3'>已送达</div>
       <div class="text" v-else-if='orderDetail.order_status==4'> 申请退货</div>
       <div class="text" v-else-if='orderDetail.order_status==5'> 已退款</div>
       <div class="text" v-else-if='orderDetail.order_status==6'> 拒绝退货退款</div>
        <div class="text" v-else>定制中</div>  
    </div>
    </div>
    <div class="address">
    <div class="addressImg">
        <img src="../assets/home-shortcut-address.png" />
    </div>
    <div class="addressTxt">
        <div class='addressProvince'>{{address.province_name + address.city_name + address.area_name}}</div>
        <div class='addressContent'>{{address.address}}</div>
        <div class='adderssName'><span style='margin-right:0.1rem;'>{{address.name}}</span><span>{{address.phone}}</span></div>
        <div class='addressID'>{{address.id_card}}</div>
    </div>
    </div>



<div class="cart-box">
    <div v-for='cartItem in cartList'>
          <div class="cart">
                <div class="cartImg">
                    <img :src="cartItem.img"/>
                </div>
                <div class="content">
                    <div class="title">{{cartItem.name}}{{cartItem.advance_str}}</div>
                    <div class="time" v-if='cartItem.source!=2'>{{cartItem.plan_title}}</div>
                    <div class="time" v-else>{{cartItem.num}}套</div>
                    <div class="price"><span>¥ </span>{{cartItem.price}} <span class='beforePrice' v-if='cartItem.price!=cartItem.beforePrice'>{{cartItem.beforePrice}}</span></div>
                </div>
                <div class='cartState' @click='handleCart(cartItem.id)'>
                      <div class='cartState1' v-if='!cartItem.showGoods'>
                            <span>查看详情</span>
                            <img src="../assets/icon-next2.png"></img>
                      </div>
                      <div class='cartState2' v-else>
                            <span>点击收起</span>
                            <img src="../assets/icon-next2.png"></img>
                      </div>
                </div>
            </div>
            <div class="products"  v-if='cartItem.showGoods' >
                <div class="orderproduct"  v-for='cartGoodsItem in cartItem.goods_info' style='border:0;'>
                    <div class="goodsImg">
                        <img :src="cartGoodsItem.index_img"/>
                    </div>
                    <div class="goodsContent">
                        <div class="goodsLeft">
                            <div class="goodsName">{{cartGoodsItem.goods_name}}</div>
                            <div class="goodsUse" >每袋{{cartGoodsItem.goods_num}}颗 <span style='margin-left:20rpx;'> ×{{cartItem.buy_days}}袋</span><span style='margin-left:20rpx;' v-if='cartItem.num!=1'>（{{cartItem.num}}套）</span></div>
                             <div class="goodsRemarks" v-if='cartGoodsItem.status==2' style=''>{{cartGoodsItem.advance_sale_remarks}}</div>
                        </div>
                        <div class="goodsPrice">¥ {{cartGoodsItem.price}}</div>
                    </div>
                </div>
            </div>
     </div>
    </div>



<div style='height:0.2rem;background:rgba(244,242,240,1);'></div>

<div class='orderBox'>
    <div class='orderRow'>
          <div class='orderRowName'>商品金额</div>
          <div class="orderRowTxt" >{{orderDetail.order_total}}元</div>
    </div>
     <div class='orderRow' v-if='orderDetail.order_disMoney!="0.00"&&orderDetail.order_disMoney>0'>
          <div class='orderRowName'>方案优惠</div>
          <div class="orderRowTxt" >- {{orderDetail.order_disMoney}}元</div>
    </div>
     <div class='orderRow'>
          <div class='orderRowName'>运费</div>
          <div class="orderRowTxt" >保税直邮</div>
    </div>
     <div class='orderRow'>
          <div class='orderRowName'>关税</div>
          <div class="orderRowTxt" >+ {{orderDetail.tariff}}元</div>
    </div>
<!--    <div class="orderRow"  v-if='orderDetail.month_discount!="0.00"'>
            <div class='orderRowName'>购买天数{{orderDetail.buy_days}}</div>
            <div class="orderRowTxt" >- {{orderDetail.month_discount}}元</div>
    </div> -->

     <div class='orderRow' v-if='orderDetail.member_discount!="0.00"&&orderDetail.member_discount>0'>
          <div class='orderRowName'>会员优惠</div>
          <div class="orderRowTxt">- {{orderDetail.member_discount}}元</div>
    </div>
     <div class='orderRow' v-if='orderDetail.sale_discount!="0.00"'>
          <div class='orderRowName'>{{orderDetail.applyTitle||"专业人士优惠"}}</div>
          <div class="orderRowTxt">- {{orderDetail.sale_discount}}元</div>
    </div>
    <div class='orderRow' v-if='orderDetail.coupon_discount!="0.00"'>
          <div class='orderRowName'>{{orderDetail.couponTitle||"优惠券"}}</div>
          <div class="orderRowTxt">- {{orderDetail.coupon_discount}}元</div>
    </div>
    <div class='orderRow'>
          <div class='orderRowName'>实际支付</div>
          <div class="orderRowTxt" ><span style="font-size:0.42rem;">{{orderDetail.need_pay}}</span>元</div>
    </div> 
</div>

  

<div class="order-info">
    <div class="title">订单信息</div>
    <div class="item" v-if='orderDetail.order_remark'>订单备注：{{orderDetail.order_remark}}</div>
    <div class="item">创建时间：{{orderDetail.create_time}}</div>
    <div class="item">支付方式：微信支付</div>
</div>

<div class="order-bar--pad"></div>
<div class="order-bar" v-show="!showLogistics">
    <div class="order-bar-box" v-if='orderDetail.order_status==0'>
        <!-- <div class="app-btn btn-normal"  @click='handleLogistics(orderDetail.id)'>订单状态</div> -->
		<div></div>
        <div class="app-btn "  @click='payOldOrder(orderDetail.id)' >确认支付</div>
    </div> 
	<div class="order-bar-box" v-else-if='orderDetail.order_status==2'>
		 <div  class="app-btn btn-normal"  v-on:click.stop='handleLogistics(item.id)'>订单状态</div>
	     <div class="app-btn" v-on:click.stop='deliveryOrder(item.id)'>确认收货</div>
	 </div>
	 <div  class="order-bar-box" v-else>
		<div></div>
	     <div class="app-btn"  @click='handleLogistics(orderDetail.id)'>订单状态</div>
	 </div>
</div>
<div class="app-mask" v-if="showLogistics" @click="closeLogistics">
    <div class="logisticsBox">
		<div class="logistics">
			<div class="close">
			    <img src="../assets/del-group.png" />
			</div>
			<div class="title">订单状态<text v-if='logisticsState'>({{logisticsState}})</text></div>
			<div class="itemsbox">
			
			    <div class="item" v-for='(item,index) in logistics'>
			        <div class="time">
			            <div>{{item.ftime}}</div>
			        </div>
			        <div class="icon">
			            <img src="../assets/icon-logistics.png" v-if='index==0'/>
			          
			            <div class="dot" wx:else></div>
			        </div>
			        <div class="content">
			            <div class="name">{{item.location}}</div>
			            <div class="des"> {{item.context}}</div>
			        </div>
			    </div>
			
			
			     <div class="item item2">
			        <div class="time">
			            <div></div>
			            <div></div>
			        </div>
			        <div class="icon">
			             <img src="../assets/icon-logistics-disabled.png" />
			        </div>
			        <div class="content">
			            <div class="name">生成订单</div>
			            <div class="des">订单支付成功</div>
			        </div>
			    </div>
			
			
			</div>
			
			
		</div>
        
    </div>
</div>





</div>








  






</div>
</template>

<script>
import plugin from '@/components/plugin.vue'
import Pay from '@/popup/Pay.vue'


export default {
  name: 'orderDetail',
  components: {
      plugin,
	  Pay
  },
  data() {
  	
      return {
       orderid:108,
       orderDetail:{},
       address:{},
       cartList:[],
	   showLogistics:false,
	   orderPayShow:false,
	   orderPayid:0,
      }
    },
    computed: {
      
    },
    mounted() {
     
    },
	beforeCreate:function() {

		if(!this.$route.params.orderid){
			this.$router.go(-1)
		}
		
	},
    created(){
		this.getOrderDetail()
		if(this.$route.params.log==1){
			this.handleLogistics()
		}
	
    },
    methods:{

        // 获取报告详情
	    getOrderDetail(){
	    	let that =this
	       this.axios({
	                  method: 'post',
	                  url:"Order/OrderDetail",
	                  data:{
	                     order_id:this.$route.params.orderid,
	                  }
	                }).then(res=>{

					res.data.orderDetail.order_disMoney=0    //方案优惠后价格
      				for (let i = 0; i < res.data.cart_list.length;i++){
                                  res.data.cart_list[i].goods_info.forEach((item)=>{

           				if (item.status==2){    //标记预售橘袋
             					res.data.cart_list[i].msgCode=2
           				}

           				item.price = Number(item.goods_price) * Number(item.goods_num) * Number(res.data.cart_list[i].buy_days) * Number(res.data.cart_list[i].plan_discount) * Number(res.data.cart_list[i].meal_discount)*Number(res.data.cart_list[i].num) 
          				item.price = that.base.changeNumber(item.price)
        			 })

        			res.data.cart_list[i].beforePrice = that.base.changeNumber(Number(res.data.cart_list[i].original_price)*Number(res.data.cart_list[i].num))
        			res.data.cart_list[i].price = that.base.changeNumber(Number(res.data.cart_list[i].total_price)*Number(res.data.cart_list[i].num))

        			res.data.orderDetail.order_disMoney += Number(res.data.cart_list[i].price)
      				}
      				res.data.orderDetail.order_disMoney = that.base.changeNumber(Number(res.data.orderDetail.order_total) - Number(res.data.orderDetail.order_disMoney ))
      				res.data.orderDetail.order_total = that.base.changeNumber(res.data.orderDetail.order_total)
			
				that.orderDetail = res.data.orderDetail
                that.address = res.data.memberAddress
  				that.cartList = res.data.cart_list
				
          		})
	},
	
	// 展开橘袋
	handleCart(cartid){
		let _cartList = this.cartList
		let indexOfItem = 0
		let newValue = {}
		_cartList.forEach((item,index)=>{
			if(cartid==item.id){
				indexOfItem = index
				newValue =item
			}
		})
		this.cartList[indexOfItem].showGoods = !this.cartList[indexOfItem].showGoods;
		this.$set(this.cartList , indexOfItem , this.cartList[indexOfItem]);
	
	},
   // 查看物流
     handleLogistics:function(){
       let that = this
   
       // 物流状态: 0 - 无轨迹，1 - 已揽收，2 - 在途中，3 - 签收, 4 - 问题件
       this.axios({
         url:'order/getLogistics',
         method: 'post',
         data: {
           order_id: this.$route.params.orderid,
		   }
         }).then( res => {
           if (!res.data) return
   
           if (!res.data.Logistics_obj)return
           
           res.data.Logistics_obj.forEach((item)=>{
             if ((Number(item.context.length) - Number(item.location.length))>65){
               item.context = item.context + "…"
             }
           })
           res.data.Logistics_obj.reverse()
           let _logisticsState
           if (res.data.state == 3) {
             _logisticsState = "已签收"
           } else if (res.data.state == 4) {
             _logisticsState = "问题件"
           }
  
             that.logistics= res.data.Logistics_obj,
             that.logisticsState= _logisticsState,
             that.showLogistics=true
       })
     },
	 // 关闭物流
	 closeLogistics(){
		 this.showLogistics=false
	 },
	// 关闭支付
	closeOrderPay(id){
		this.orderPayid = 0
		this.orderPayShow=false
		console.log(id)
		this.toOrderDetail(id)
	},
	// 是否老订单
	payOldOrder(id){
		this.orderPayid = id
		this.orderPayShow = true
	},
	deliveryOrder(id){
		let that = this
		 
		this.axios({
		  url:'Order/receiveOrder',
		  method: 'post',
		  data: {
				order_id: this.$route.params.orderid,
				}
		}).then( res => {
			  let _orderDetail = that.orderDetail
			  _orderDetail.order_status = 3
			  this.orderDetail =Object.assign({},_orderDetail)
			 
		})
	}
  }
}
</script>
<style>
#orderDetail{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  text-align: left;
  overflow-y: auto;
}
#orderDetail::-webkit-scrollbar {display:none}



.order-status  {
    position: relative;
    color: #fff;
}
.order-status .status-bg {
    width: 100%;
    position: relative;
    z-index: 2;
    pointer-events: none;
}
.order-status .order-content {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.order-status .icon img {
    width: 0.6rem;
    height: 0.5rem;
}
.order-status .text {
    font-size: 0.36rem;
    padding-top: 0.2rem;
}
.order-status .content .text{
	color:#fff;
}
.address {
    padding:0.3rem 0.4rem;
    width: 7.5rem;
    min-height: 2.4rem;
    box-sizing: border-box;
    display: flex;
}
.addressImg{
    width: 0.4rem;
    height: 0.51rem;
    margin-right: 0.25rem;
}
.addressImg img{
    width: 0.4rem;
    height: 0.51rem;
    display: block;
}
.addressTxt{
  flex: 1;
}
.addressProvince{
  font-size:0.24rem;
  color:rgba(120,120,120,1);
  line-height:0.33rem;
  margin-bottom: 0.1rem;
}
.addressContent{
  font-size:0.3rem;
  font-weight:600;
  color:rgba(20,20,20,1);
  line-height:0.42rem;
  margin-bottom: 0.16rem;
}
.adderssName{
  font-size:0.24rem;
  color:rgba(120,120,120,1);
  line-height:0.33rem;
  margin-bottom: 0.1rem;
}
.addressID{
  font-size:0.24rem;
  color:rgba(120,120,120,1);
  line-height:0.33rem;
}
.cart-area {
    background: #fff;
    padding: 0 0.33rem;
}
.cart {
    padding: 0.3rem 0;
    display: flex;
    border-bottom: 0.04rem solid #F4F2F0;
}
.cart .thumb {
    width: 1.7rem;
    height: 1.7rem;
}
.cart .thumb img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    flex-shrink: 0;
}
.cart .content {
    padding-left: 0.3rem;
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.cart .content .title {
    font-weight: bold;
    font-size: 0.32rem;
}
.cart .content .time {
    font-size: 0.24rem;
    color: #9B9B9B;
}
.cart .content .price {
    color: #C25E4D;
    font-weight: bold;
    font-size: 0.32rem;
}
.cart .content .price span {
    font-size: 0.26rem;
    font-weight: normal;
}

.products .orderproduct {
    padding: 0.3rem 0;
    display: flex;
    border-bottom: 0.04rem solid #F4F2F0;
}
.products .orderproduct .thumb {
    width: 1.1rem;
    height: 1.02rem;
}
.products .orderproduct .thumb img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    flex-shrink: 0;
}
.products .orderproduct .content {
    padding-left: 0.3rem;
    flex-grow: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.products .orderproduct .content .title {
    font-weight: bold;
    padding-bottom: 0.2rem;
}
.products .orderproduct .content .des {
    color: #9B9B9B;
    font-size:0.24rem;
    padding-top:0.1rem;
}
.products .orderproduct .price{
    color: #666666;
    font-family:'Bebas';
    font-size: 0.32rem;
}
.totals {
    padding: 0.2rem 0;
}
.totals .item {
    display: flex;
    padding-top: 0.15rem;
}
.totals .item div:first-child {
    flex: 1;
    text-align: right;
    color: #9B9B9B;
}
.totals .item .price {
    width: 5rem;
    text-align: right;
    font-size: 3.2rem;
     font-family: 'Bebas';
    color:rgba(194, 94, 77, 1);
    overflow: hidden;
}
.cart-area .total {
    padding: 0.2rem 0;
    position: relative;
    text-align: right;
    color: #9B9B9B;
    margin-top: 0.15rem;
    display: flex;
}
.cart-area .total:after {
    position: absolute;
    content:'';
    right: 0;
    top: 0;
    left: 40%;
    height: 3px;
    background: #F4F2F0;
}
.cart-area .total div:first-child {
    font-size: 0.28rem;
    text-align: right;
    line-height: 0.6rem;
    color: #9B9B9B;
    flex: 1;
}
.cart-area .total .price{
    width: 2rem;
    text-align: right;
    font-size: 0.32rem;
     font-family: 'Bebas';
    color:rgba(20,20,20,1);
}
.order-info .title {
    position: relative;
    padding-left: 0.2rem;
    margin: 0.3rem 0.2rem;
	font-size: 0.32rem;
}
.order-info .title:before {
    position: absolute;
    content: "";
    left: 0;
    top: 15%;
    bottom: 5%;
    width: 0.03rem;
    background: #C25E4D;
    border-radius:0.04rem;
}
.order-info .item {
    padding: 0.1rem 0.4rem;
    color: #666;
    font-size: 0.3rem;
}

.order-bar--pad {
    height: 3rem;
}
.order-bar {
    width: 7.5rem;
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0); 
    height: 1.77rem;
    padding: 0.4rem 0.5rem 0.5rem;
    background: #fff;
    box-shadow: 0px -6px 20px 0px rgba(0,0,0,0.08);
    text-align: right;
}
.order-bar-box{
	width: 100%;
	display:flex;
	justify-content:space-between;
}
.app-btn{
  font-size: 0.26rem;
}
.order-bar .app-btn {
    margin-left:0.22rem;

}

.order-bar div.app-btn {
    height: 0.86rem;
    width: 1.95rem;
    line-height: 0.86rem;
    border: 1px solid #C25E4D;
}
.order-bar div.btn-normal {
    border-color: #C1C1C1;
    background: #fff;
    color: #333;
}
.logisticsBox{
	width: 7.5rem;
	 position: fixed;
	 left: 50%;
	 bottom: 0;
	 max-height: 80%;
	transform: translate(-50%,0); 
}
.logistics {
    background: #fff;
	width: 7.5rem;
	z-index: 600;
    position: absolute;
	box-sizing: border-box;
    left: 0;
	bottom: 0;
    padding: 0.4rem 0.3rem;
   /* max-height: 80%; */
    overflow: hidden;
}
.logistics .close {
    position: absolute;
    right: 0.4rem;
    top: 0.4rem;
}
.logistics .close img {
    width: 0.25rem;
    height:0.27rem;
}
.logistics .title {
    text-align: center;
    font-size: 0.36rem;
    font-weight: bold;
    position: relative;
    padding-bottom: 0.3rem;
}
.logistics .title text{
    font-size: 0.32rem ;
    font-weight: 500 ;
}
.logistics .title:after {
    position: absolute;
    content: "";
    left: 35%;
    right: 35%;
    bottom: 0;
    height: 0.1rem;
    background: #C25E4D;
    border-radius: 0.12rem;
}
.logistics .itemsbox {
    padding: 0.45rem 0;
	box-sizing: border-box;
	
    width: 6.6rem;
    color: #9b9b9b;
    max-height:80vh; 
    overflow-y: auto;
	overflow-x: hidden;
}
.logistics .itemsbox::-webkit-scrollbar {display:none}
.logistics .itemsbox .item {
    display: flex;
    width: 6.6rem;
    min-height: 0.77rem;
    color: #9b9b9b;
    margin-bottom: 0.2rem;
}
.item2{
  height: 1.5rem;
}
.logistics .itemsbox .item:first-child {
    color: #141414;
    
}
.logistics .itemsbox .item>div {
    /* margin: 0 0.2rem; */
    flex-shrink: 0;
}
.logistics .itemsbox .item .time {
    font-size: 0.2rem;
    text-align: right;
    width: 1.2rem;
    
}
.logistics .itemsbox .item .icon {
    width: 0.5rem;
    height: 0.5rem;
    margin-top: 0.1rem;
    margin-right: 0.2rem;
    margin-left: 0.1rem;
    position: relative;
}
.logistics .itemsbox .item .icon:after {
    position: absolute;
    content: "";
    left: 45%;
    width: 0.02rem;
    height: 3rem;
    bottom: -2.5rem;
    background: #eee;
    z-index: -1;
}
.logistics .itemsbox .item:last-child .icon:after {
    width: 0;
}
.logistics .itemsbox .item .icon .dot {
    width: 10px;
    height: 10px;
    background: #eee;
    border-radius: 100%;
    margin: 10rpx auto;
}
.logistics .itemsbox .item .icon img {
    width: 100%;
    height: 100%;
}
.logistics .itemsbox .item .name {
    font-size: 0.28rem;
    font-weight: bold;
}
.logistics .itemsbox .item .des {
    font-size: 0.24rem;
}
.logistics .itemsbox .item .content{
  width: 4.7rem;
}



/* 橘袋信息 */
.cart-box {
    background: #fff;
    padding: 0 0.4rem;
}
.cart {
    padding: 0.3rem 0;
    display: flex;
    border-bottom: 1px solid rgba(244,242,240,1);
    position: relative;
}
.cartImg {
    width: 1.7rem;
    height: 1.7rem;
}
.cartImg img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    flex-shrink: 0;
}
.cart .content {
    padding-left: 0.35rem;
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.cart .content .title {
    font-size:0.32rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height:0.45rem;
}
.cart .content .time {
    font-size:0.24rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(155,155,155,1);
    line-height:0.33rem;
}
.cart .content .price {
    width: 4rem;
    font-size:32rpx;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(194,94,77,1);
}
.cart .content .price text {
    font-size: 0.26rem;
    font-weight: normal;
}
.cartState{
  position: absolute;
  bottom:0;
  right:-0.16rem;
  padding: 0.35rem 0.4rem;
}
.cartState div{
  height:0.3rem;
  font-size:0.22rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(142,142,142,1);
  line-height:0.3rem;
}
.cartState img{
  width:0.1rem;
  height: 0.2rem;
  position: relative;
  left: 0.16rem;
  top:0.01rem;
}
.cartState1 img{
  transform: rotate(90deg);
}
.cartState2 img{
  transform: rotate(270deg);
}





.products .product {
    padding: 0.12rem 0;
    display: flex;
    margin-bottom: 40rpx;
}
.goodsImg {
    width: 100rpx;
    height: 100rpx;
}
.goodsImg img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
}
.goodsContent {
    margin-left: 0.24rem;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.01rem solid rgba(244,242,240,1);
    padding-bottom: 0.25rem;
}
.goodsLeft{
  flex: 1;
}
.goodsName {
    font-size:0.28rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height:0.48rem;
    margin-bottom: 0.16rem;
}
.goodsUse{
    font-size:0.24rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(155,155,155,1);
    line-height:0.33rem;

}
.goodsPrice {
    width: 1.8rem;
    text-align: right;
    font-size:0.28rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:0.4rem;
    letter-spacing:0.01rem;
}

/* 支付计算信息 */
.orderBox{
  background: #fff;
  padding: 0 0.4rem;
  margin-bottom: 0.2rem;
  width: 7.5rem;
  box-sizing: border-box;
}
.orderRow{
  height: 1rem;
  line-height: 1rem;
  display: flex;
  justify-content: space-between;
  border-bottom:1px solid rgba(244,242,240,1); 
}
.orderRowName{
  height: 1rem;
  font-size:0.3rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20,20,20,1);
  position: relative;
}
.orderRowTxt{
  height: 1rem;
  font-size:0.28rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(120,120,120,1);
}
.couponDelImg{
  position: absolute;
  top:0.45rem;
  right: -0.4rem;
  width: 0.2rem;
  height: 0.2rem;
}

.beforePrice{
  font-size:0.2rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(137,137,137,1);
  text-decoration: line-through;
  margin-left: 0.1rem;
}
.goodsRemarks{
  
  padding-top: 0.16rem;
    font-size:0.24rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(194,94,77,1);
    line-height:0.33rem;
}
</style>